import teamGroupStyles from "../../styles/ganttChart/teamgroups.module.css";
import { TeamGroupColorMaps } from "../../utils/TeamColorGroupUtils";
import TextChip from "../UI/chips/TextChip";

const EmployeeTeamsComponent = ({
  teamGroupColorMaps,
  columnWidth,
  leftOffset,
}: {
  teamGroupColorMaps: TeamGroupColorMaps;
  columnWidth: number;
  leftOffset: number;
}) => {
  const { colorGroupCounts, colorGroupToTeamNumberMap } = teamGroupColorMaps;

  return (
    <div
      className={teamGroupStyles.teamgroupContainer}
      style={{
        paddingLeft: leftOffset,
        borderBottom: "1px solid var(--col-border-primary)",
      }}
    >
      {(Object.entries(colorGroupToTeamNumberMap) as [string, string][]).map(
        ([colorGroup, teamName]) => (
          <div
            key={teamName}
            className={teamGroupStyles.teamgroupTeamWrapper}
            style={{
              width: colorGroupCounts[colorGroup] * columnWidth,
              marginLeft: "-1px",
            }}
          >
            <TextChip
              text={teamName}
              bgColor={"#" + colorGroup}
              classes={teamGroupStyles.teamgroupChip}
            />
          </div>
        ),
      )}
    </div>
  );
};

export default EmployeeTeamsComponent;
